import { categoryKey } from '../../scripts/Editor/utils/productionUtils';

// Display only: preserve legacy person elements, shared records and scene links.
export const isPersonElement = element => ['cast', 'backgroundextras'].includes(categoryKey(element.category));
export const productionOnly = data => {
  const elements = (data.elements || []).filter(e => !isPersonElement(e));
  const keys = new Set(elements.map(e => e.key));
  return { ...data, elements, scenes: (data.scenes || []).map(s => ({ ...s, elementKeys: s.elementKeys.filter(k => keys.has(k)) })) };
};
export const memberNames = members => (members || []).map(m => m.name).join(', ');